<template>
  <PageContent type="center" :compClass="'flex flex-col space-y-6'">
    <div class="flex flex-row justify-between items-center content-center">
      <h1 class="text-2xl font-medium">
        Networks
        <span class="text-lg text-gray-500">({{ networks.length }})</span>
      </h1>
      <button
        class="w-8 h-8 bg-blue-600 text-white rounded-full border-0 foucs:outline-none hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        v-on:click="openAddNetworkModal"
      >
        <i class="fa-solid fa-plus"></i>
      </button>
    </div>

    <div
      class="space-y-2"
      v-for="type in ['national', 'local', 'internal']"
      v-bind:key="type"
    >
      <div class="flex flex-row">
        <h2 class="text-xl font-medium text-gray-700">
          {{ type | capitalize }} Networks
        </h2>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        <router-link
          :to="{ name: 'AdminNetworkView', params: { id: network.id } }"
          class="col-span-1 bg-white p-3 rounded-lg relative cursor-pointer focus:outline-none transition hover:bg-gray-200"
          v-for="network in networkType(type)"
          v-bind:key="network.id"
        >
          {{ network.name }}
        </router-link>
      </div>
    </div>

    <NetworkAddModal />
    <NetworkEditModal />
  </PageContent>
</template>

<script>
import * as Config from "@/config";

import PageContent from "@/components/PageContent";
import CustomTable from "@/components/general/CustomTable";
import NetworkAddModal from "@/screens/admin/modals/NetworkAddModal";
import NetworkEditModal from "@/screens/admin/modals/NetworkEditModal";

export default {
  name: "AdminNetworks",
  data() {
    return {
      networks: [],
      polling: false
    };
  },
  components: { PageContent, CustomTable, NetworkAddModal, NetworkEditModal },
  mounted() {
    this.getNetworks();

    this.$nextTick(
      function() {
        this.$eventBus.$on("admin-network-refresh-data", this.getNetworks);
      }.bind(this)
    );
  },
  methods: {
    networkType: function(val) {
      return this.networks.filter(network => {
        return network.marketType == val;
      });
    },
    async getNetworks() {
      this.polling = true;
      let res = await this.$http.get(Config.apiPath + "/api/v2/admin/networks");
      this.networks = res.data;
      this.polling = false;
    },
    openAddNetworkModal() {
      this.$eventBus.$emit("admin-add-network-open-modal");
    },
    openEditNetworkModal(data) {
      this.$eventBus.$emit("admin-edit-network-open-modal", data);
    }
  }
};
</script>
